import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Col, Row } from 'reactstrap';
import { postAPI } from "../../Base/API";
import { ErrorAlert } from "../../Base/ErrorAlert";
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import moment from 'moment';
import { ChartCard } from '../../Base/Common/CommonUIComponents';
import { getColorPalette } from '../../Base/Common/ReferenceDataFunctions';


class Engagement extends Component {
    constructor(props) {
        super(props);

        this.state = {
            error: [],
            block: false,
            eventCountByEventName: []
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.search === true && nextProps.search !== this.props.search) {
            this.getData();
        }
    }

    componentDidMount() {
        this.getData();
    }

    getData = () => {
        this.setState({ block: true });

        const body = {
            startDate: moment(this.props.startDate).format("YYYY-MM-DD"),
            endDate: moment(this.props.endDate).format("YYYY-MM-DD"),
            dimensions: ["eventName", "unifiedScreenClass"],
            metrics: ["eventCount", "screenPageViews"],
            aggregation: []
        }

        const body2 = {
            startDate: moment(this.props.startDate).format("YYYY-MM-DD"),
            endDate: moment(this.props.endDate).format("YYYY-MM-DD"),
            dimensions: ["date"],
            metrics: ["eventCount", "screenPageViews", "activeUsers", "engagedSessions", "sessions", "userEngagementDuration"],
            aggregation: []
        }

        postAPI(result => {
            const { data, error } = result;

            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });

                return;
            }
            if (data) {
                let eventCountByEventName = [[this.props.intl.formatMessage({ id: "WidgetStatistics.EventCount" }), this.props.intl.formatMessage({ id: "WidgetStatistics.EventName" }), { role: 'style' }]];

                data.rows && data.rows.forEach((row) => {
                    eventCountByEventName = this.props.updateChartArray(eventCountByEventName, row, 0, 0, 'BarChart');
                });

                this.setState({ eventCountByEventName });
            }
            else this.setState({ block: false });
        }, `/api/Voucher/Hotel/v1/googleanalytics`, body);


        postAPI(result => {
            const { data, error } = result;

            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });

                return;
            }
            if (data) {
                let eventCount = 0, totalEngTime = 0, totalUsers = 0;
                let avgEngTimePerDay = [[this.props.intl.formatMessage({ id: "WidgetStatistics.Date" }), this.props.intl.formatMessage({ id: "WidgetStatistics.AvgEngagementTimePerActiveUser" })]];
                let eventCountPerDay = [[this.props.intl.formatMessage({ id: "WidgetStatistics.Date" }), this.props.intl.formatMessage({ id: "WidgetStatistics.EventCount" })]];
                let avgEngTimePerSession = [[this.props.intl.formatMessage({ id: "WidgetStatistics.Date" }), this.props.intl.formatMessage({ id: "WidgetStatistics.AvgEngagementTimePerSession" })]];

                //Chart dates
                avgEngTimePerDay.push([moment(this.props.startDate).format('YYYY-MM-DD'), [0, 0, 0]]);
                eventCountPerDay.push([moment(this.props.startDate).format('YYYY-MM-DD'), 0]);
                avgEngTimePerSession.push([moment(this.props.startDate).format('YYYY-MM-DD'), [0, 0, 0]]);

                var currDate = moment(this.props.startDate);
                while (currDate.add(1, 'days').diff(this.props.endDate) < 0) {
                    avgEngTimePerDay.push([moment(currDate).format('YYYY-MM-DD'), [0, 0, 0]]);
                    eventCountPerDay.push([moment(currDate).format('YYYY-MM-DD'), 0]);
                    avgEngTimePerSession.push([moment(currDate).format('YYYY-MM-DD'), [0, 0, 0]]);
                }

                data.rows && data.rows.forEach((row) => {
                    avgEngTimePerDay = this.setValuesByDay(avgEngTimePerDay, row, 5, 2, true);
                    eventCountPerDay = this.setValuesByDay(eventCountPerDay, row, 0, null, false);
                    avgEngTimePerSession = this.setValuesByDay(avgEngTimePerSession, row, 5, 4, true);

                    eventCount += parseInt(row.metricValues[0].value);
                    totalEngTime += parseInt(row.metricValues[5].value);
                    totalUsers += parseInt(row.metricValues[2].value);
                });

                this.setState({ avgEngTimePerDay, eventCountPerDay, avgEngTimePerSession, eventCount, avgEngTime: (totalEngTime / totalUsers), block: false });
            }
        }, `/api/Voucher/Hotel/v1/googleanalytics`, body2);
    }

    setValuesByDay = (array, row, metric1, metric2, time) => {
        const index = array.findIndex(el => moment(el[0]).isSame(row.dimensionValues[0].value));

        if (index !== -1) {
            if (time) {
                const time = moment.utc(parseInt(row.metricValues[metric1].value) / parseInt(row.metricValues[metric2].value) * 1000);
                array[index][1] = [moment(time).format('HH'), moment(time).format('mm'), moment(time).format('ss'),];
            }
            else {
                array[index][1] += parseInt(row.metricValues[metric1].value);
            }
        }

        return array;
    }


    render() {
        const { block, eventCount, avgEngTimePerDay, avgEngTimePerSession, avgEngTime } = this.state;
        const { valuesCard } = this.props;
        
        const lineOptions = {
            legend: "none",
            vAxis: {
                minValue: 0,
                format: 'HH \'h\' mm \'m\' ss \'s\''
            },
            series: [{ color: getColorPalette()[0] }]
        };

        return (
            <BlockUi tag="div" blocking={block}>
                <ErrorAlert error={this.state.error} />
                <Row>
                    <Col>
                        {valuesCard(<FormattedMessage id="WidgetStatistics.AverageEngagementTime" />, avgEngTime && !isNaN(avgEngTime) ? moment.utc(avgEngTime * 1000).format('mm:ss') : 0)}
                    </Col>
                    <Col>
                        {valuesCard(<FormattedMessage id="WidgetStatistics.EventCount" />, eventCount)}
                    </Col>
                </Row>

                <Row className="my-3">
                    <Col>
                        {avgEngTimePerDay && avgEngTimePerDay.length > 1 ?
                            <ChartCard
                                chartType='LineChart'
                                data={avgEngTimePerDay}
                                options={lineOptions}
                                title={<FormattedMessage id="WidgetStatistics.AverageEngagementTimePerUser" />}
                            />
                            : ''}
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {avgEngTimePerSession && avgEngTimePerSession.length > 1 ?
                            <ChartCard
                                chartType='LineChart'
                                data={avgEngTimePerSession}
                                options={lineOptions}
                                title={<FormattedMessage id="WidgetStatistics.AvgEngagementTimePerSession" />}
                            />
                            : ''}
                    </Col>
                </Row>
            </BlockUi>
        )
    }
}

export default injectIntl(Engagement);
